import { OrganizationType, Permission } from '../dto';

export interface UserDto {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isAdmin: boolean;
  isActive: boolean;
  organizationId?: string;
  organization: UserOrganizationDto | null;
  birthDate: string | null;
  city: string | null;
  country: string | null;
  phone: string | null;
  receiveEmails: boolean;
  roles: UserRole[];
  state: string | null;
  pictureUrl: string | null;
  streetAddress: string | null;
  zipCode: string | null;
  permissions: Permission[];
}

export enum ApprovalStatus {
  Unknown = 'Unknown',
  PendingApproval = 'PendingApproval',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Configured = 'Configured',
  PendingConfiguration = 'PendingConfiguration',
}

export interface UserOrganizationDto {
  approvalStatus: ApprovalStatus;
  id: string;
  name: string;
  type: OrganizationType;
}

export interface RegisterUserDto {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export interface KeycloakUserParamsDto {
  email: string;
  showMessage?: boolean;
}

export interface EditUserDto {
  firstName: string;
  lastName: string;
  birthDate: string;
  country: string;
  city: string;
  streetAddress: string;
  zipCode: string;
  phone: string;
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export enum UserRole {
  Administrator = 'Administrator',
  Member = 'Member',
  Manager = 'Manager',
  BasicAccountOwner = 'BasicAccountOwner',

  AmbassadorAccountOwner = 'AmbassadorAccountOwner',

  MerchantAccountOwner = 'MerchantAccountOwner',
  DistributorAccountOwner = 'DistributorAccountOwner',
  BrandAccountOwner = 'BrandAccountOwner',

  DistributorAccountUser = 'DistributorAccountUser',
  DistributorAccountManagerA = 'DistributorAccountManagerA',
  DistributorAccountManagerB = 'DistributorAccountManagerB',
  DistributorAccountManagerC = 'DistributorAccountManagerC',

  MerchantAccountUser = 'MerchantAccountUser',
  MerchantAccountManagerA = 'MerchantAccountManagerA',
  MerchantAccountManagerB = 'MerchantAccountManagerB',
  MerchantAccountManagerC = 'MerchantAccountManagerC',

  BrandAccountUser = 'BrandAccountUser',
  BrandAccountManagerA = 'BrandAccountManagerA',
  BrandAccountManagerB = 'BrandAccountManagerB',
  BrandAccountManagerC = 'BrandAccountManagerC',
}
